import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { GetUserFeatureFlagsOut } from '../types/ecommerce/generated.codegen';

const DEFAULT_FEATURE_FLAGS: GetUserFeatureFlagsOut = {
  triangularTransaction: false,
  multiYearInsurance: false,
  multiCd: false,
  enableFintechSimulation: false,
  distributionCenterIdsWithHvacSell: [],
  hvacCategoryHighlightEnabled: false,
  crossSellKit: false,
  solfacilFinancingStandaloneProduct: false,
};

export const useFeatureFlagsStore = defineStore('featureFlags', () => {
  const featureFlags = ref<GetUserFeatureFlagsOut>({
    ...DEFAULT_FEATURE_FLAGS,
  });
  const featureFlagsReady = ref(false);

  const triangularTransaction = computed(
    () => featureFlags.value.triangularTransaction,
  );
  const multiYearInsurance = computed(
    () => featureFlags.value.multiYearInsurance,
  );
  const multiCd = computed(() => featureFlags.value.multiCd);
  const enableFintechSimulation = computed(
    () => featureFlags.value.enableFintechSimulation,
  );
  const distributionCenterIdsWithHvacSell = computed(
    () => featureFlags.value.distributionCenterIdsWithHvacSell,
  );
  const hvacCategoryHighlightEnabled = computed(
    () => featureFlags.value.hvacCategoryHighlightEnabled,
  );
  const crossSellKit = computed(() => featureFlags.value.crossSellKit);
  const solfacilFinancingStandaloneProduct = computed(
    () => featureFlags.value.solfacilFinancingStandaloneProduct,
  );
  function setFeatureFlags(value: GetUserFeatureFlagsOut) {
    const { __typename, ...features } = value;
    featureFlags.value = features;
    featureFlagsReady.value = true;
  }

  function resetFeatureFlags() {
    featureFlags.value = { ...DEFAULT_FEATURE_FLAGS };
    featureFlagsReady.value = false;
  }

  function finishFeatureFlagsLoading() {
    featureFlagsReady.value = true;
  }

  return {
    featureFlags,
    featureFlagsReady,

    triangularTransaction,
    multiYearInsurance,
    multiCd,
    enableFintechSimulation,
    distributionCenterIdsWithHvacSell,
    hvacCategoryHighlightEnabled,
    crossSellKit,
    solfacilFinancingStandaloneProduct,

    setFeatureFlags,
    resetFeatureFlags,
    finishFeatureFlagsLoading,
  };
});
